import { Link, Outlet } from "react-router";
import UserDropdown from "../components/header/UserDropdown";

const BuildingSelectorLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Simple Header */}
      <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-200 dark:border-gray-800 dark:bg-gray-900">
        <div className="flex items-center justify-between px-4 py-3 mx-auto max-w-7xl sm:px-6 lg:px-8">
          {/* Logo */}
          <Link to="/sites" className="flex items-center gap-3">
            <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-white shadow-md flex items-center justify-center overflow-hidden">
              <img
                src="/images/logo/sbm-logo.png"
                alt="SBM Logo"
                className="w-8 h-8 object-contain"
              />
            </div>
            <span className="text-xl font-semibold text-gray-800 dark:text-white">
              Package App
            </span>
          </Link>

          {/* User Dropdown */}
          <UserDropdown />
        </div>
      </header>

      {/* Main Content */}
      <main className="px-4 py-8 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <Outlet />
      </main>
    </div>
  );
};

export default BuildingSelectorLayout;
